const TOKEN_KEY = 'coren_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`/api${path}`, { ...options, headers });

  if (res.status === 401) {
    setToken(null);
    window.dispatchEvent(new Event('coren:sessao-expirada'));
  }

  const contentType = res.headers.get('content-type') || '';
  const corpo = contentType.includes('application/json') ? await res.json() : null;

  if (!res.ok) {
    const erro = new Error((corpo && corpo.erro) || `Erro ${res.status}`);
    erro.status = res.status;
    erro.corpo = corpo;
    throw erro;
  }
  return corpo;
}

export const api = {
  get: (path) => apiFetch(path),
  post: (path, body) => apiFetch(path, { method: 'POST', body: JSON.stringify(body) }),
  put: (path, body) => apiFetch(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: (path, body) => apiFetch(path, { method: 'PATCH', body: JSON.stringify(body) }),
  del: (path, body) => apiFetch(path, { method: 'DELETE', ...(body !== undefined ? { body: JSON.stringify(body) } : {}) })
};
